// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"g8-z","button":"h8-z","disabled":"i8-z","creditCard":"j8-z","wrapper":"k8-z"};